import {
  COLORS,
  FONT_SIZES,
  mediaTabletAndUp,
  Z_INDEXES,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';

export const StyledBorderedlinkText = styled.div`
  z-index: ${Z_INDEXES.TADARIDA_HEADER_IMG_TEASER_CTA};
  background-color: transparent;
  margin-top: 4px;
  font-size: ${FONT_SIZES.px14};

  @media ${mediaTabletAndUp} {
    font-size: ${FONT_SIZES.px16};
  }

  color: ${COLORS.White};

  text-align: center;
  border-radius: 3px;
  padding: 5px 10px 6px;
  border: 1px solid ${COLORS.White};
`;
